module.exports = __webpack_public_path__ + "static/media/tier-2.3914a545.jpg";